import * as React from "react";
import { API } from "../API";
import LoadingScaffold from "../components/LoadingScaffold";
import { SettingsNotificationsScreen } from "../components/SettingsNotificationsScreen";
import { ApiWithRetry } from "../ExponentialBackOffNetworkRequest";
import { isLoading, Loading, loading } from "../Loading";
import { CaregiverNotificationSettings } from "../messages";
import { retryableModalNetworkRequest } from "../NetworkRequest";
import { STRINGS } from "../strings";
import { translate } from "../translate";

interface SettingsNotificationActivityProps {
  api: API;
  onBackClick: () => void;
}

interface SettingsNotificationActivityState {
  notificationsSetting: CaregiverNotificationSettings | Loading;
}

export class SettingsNotificationActivity extends React.Component<
  SettingsNotificationActivityProps,
  SettingsNotificationActivityState
> {
  constructor(props: SettingsNotificationActivityProps) {
    super(props);
    this.state = {
      notificationsSetting: loading(),
    };

    this.getInitialNotifications();
  }

  private exponentialBackOff = new ApiWithRetry();

  componentWillUnmount() {
    this.exponentialBackOff.cancel();
  }

  async getInitialNotifications() {
    const notificationSettings = await this.exponentialBackOff.fetch(() =>
      this.props.api.getNotificationSettings()
    );
    if (notificationSettings !== null) {
      this.setState({
        notificationsSetting: notificationSettings,
      });
    }
  }

  handleClickGoBack = () => {
    this.props.onBackClick();
  };

  handleNotificationSettingsChange = async (value: CaregiverNotificationSettings) => {
    const result = await retryableModalNetworkRequest(async (): Promise<true> => {
      await this.props.api.setNotificationSettings(value);
      return true;
    }, true);

    if (result === true) {
      this.setState(() => {
        return {
          notificationsSetting: value,
        };
      });
    }
  };

  render() {
    if (isLoading(this.state.notificationsSetting)) {
      return (
        <LoadingScaffold
          title={translate(STRINGS.NOTIFICATIONS)}
          onClickGoBack={this.handleClickGoBack}
        />
      );
    }

    return (
      <SettingsNotificationsScreen
        notificationSettings={this.state.notificationsSetting}
        onChange={this.handleNotificationSettingsChange}
        onClickGoBack={this.handleClickGoBack}
      />
    );
  }
}
